import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ScriptService } from './core/services/script/script.service';
import Intercom from "@intercom/messenger-js-sdk";
import { AuthenticationService } from './core/services/authentication/authentication.service';
import { IntercomData } from './models/interfaces/intercomData';
import { Subscription } from 'rxjs';
import { AyenServices } from './core/services/ayen-services/ayen-services.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: [],
})
export class AppComponent implements OnInit, AfterViewInit {

  userSub: Subscription;
  lastUserId: string | null = null;
  title = 'admin-panel';
  appID = 'xlyl0fh2';

  constructor(
    loadService: ScriptService,
    private authenticationService: AuthenticationService,
    private ayenServices: AyenServices
  ) {
    loadService.checkScriptLoaded();
  }

  ngOnInit(): void {
    // Load feature flags once at app initialization
    // All components can then access via featureFlags$
    this.ayenServices.getFeatureFlags().subscribe({
      next: (flags) => console.log('Feature flags loaded:', flags?.length || 0, 'flags'),
      error: (err) => console.warn('Failed to load feature flags:', err)
    });
  }

  ngAfterViewInit(): void {
    this.userSub = this.authenticationService.currentLoggedInUser.subscribe(user => {
      this.handleIntercom(user?.user);
    });
  }

  handleIntercom(user) {
    // Prevent duplicate Intercom calls for the same user
    const userId = user?.id || null;
    if (userId === this.lastUserId) return;
    this.lastUserId = userId;

    const intercomData: IntercomData = {
      app_id: this.appID,
      created_at: Date.now(),
      domain: this.title,
      ...(user && {
        user_id: user.id || '',
        name: user.full_name || '',
        email: user.profile?.email || '',
        user_type: user.profile?.user_type_object?.name,
      }),
    };
    Intercom({ ...intercomData });
  }

  ngOnDestroy(): void {
    if (this.userSub) {
      this.userSub.unsubscribe();
    }
  }
}
